import React from 'react'
import messageFeatureImg from '../../assets/message_feature.png'
import videoCallFeatureImg from '../../assets/video_call_feature.png'
const FeatureComponent = () => {
  return (
    <>
      <p className="firefly-features-header">minera（ミネラ）の機能</p>
      <div className="user-list-feature">
        <div className="user-list-description">
          <p className="title">
            仕事・トレーニング・趣味が合う人にメッセージを送ってみよう
          </p>
          <p>
            お互いに悩みを相談することで、モチベーション維持につながりますよ。
          </p>
          <br />
          <p>
            全国各地の見ず知らずの人と、気軽なコミュニケーションをいつでもどこでも手軽に楽しめます。
          </p>
        </div>
        <div className="user-list-feature-img">
          <img src={messageFeatureImg} />
        </div>
      </div>
      <div className="video-call-feature">
        <div className="video-call-feature-img">
          <img src={videoCallFeatureImg} />
        </div>
        <div className="video-call-description">
          <p className="title">
            音声・ビデオ通話を使って様々な悩みを相談してみよう！
          </p>
          <p>
            ビデオ通話でお相手の顔や表情を見ながら相談することで、心が打ち解け相談しやすいです。
          </p>
          <br />
          <p>あなたのモチベーションを上げるための相談をしましょう。</p>
          <br />
          <p>モチベーションが下がったときにmineraを活用してあげていこう。</p>
        </div>
      </div>
    </>
  )
}
export default FeatureComponent
